import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';

export const experimentalTeamCalendar_Hide: ExperimentalMutations['experimentalTeamCalendar_Hide'] =
	(_, { calendarIds, action }, { network }) => {
		if (action == 'PUT' || action == 'DELETE') {
			const searchParams = new URLSearchParams();
			// TODO FIXME `calendarIds` can be `null` or `undefined` according to experimental schema types. Either this
			// case needs to be properly handled, or the schema type needs to be fixed
			calendarIds!.forEach((id) => {
				searchParams.append('subCalendarId', id);
			});

			return network
				.cfetch(`/wiki/rest/calendar-services/1.0/calendar/preferences/events/hidden.json`, {
					method: action,
					body: searchParams.toString(),
					headers: {
						'Content-Type': MediaType.X_WWW_FORM_URLENCODED,
					},
				})
				.then(() => true);
		} else {
			return Promise.reject(new Error('Invalid Action.'));
		}
	};

export const experimentalTeamCalendar_Watch: ExperimentalMutations['experimentalTeamCalendar_Watch'] =
	(_, { calendarId, action }, { network }) => {
		if (action == 'PUT' || action == 'DELETE') {
			return network
				.cfetch(`/wiki/rest/calendar-services/1.0/calendar/preferences/subcalendars/watch.json`, {
					method: action,
					body: new URLSearchParams({ subCalendarId: calendarId }).toString(),
					headers: {
						'Content-Type': MediaType.X_WWW_FORM_URLENCODED,
					},
				})
				.then(() => true);
		} else {
			return Promise.reject(new Error('Invalid Action.'));
		}
	};

export const experimentalTeamCalendar_EventType_Disable: ExperimentalMutations['experimentalTeamCalendar_EventType_Disable'] =
	(_, { calendarId, disableEventTypes }, { network }) => {
		const searchParams = new URLSearchParams();
		searchParams.append('subCalendarId', calendarId);
		disableEventTypes!.forEach((eventTypeId: string) => {
			searchParams.append('disableEventTypes', eventTypeId);
		});

		return network
			.cfetch(`/wiki/rest/calendar-services/1.0/calendar/eventtype/disable.json`, {
				method: 'PUT',
				headers: {
					Accept: MediaType.JSON,
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				},
				// @ts-ignore
				body: searchParams.toString(),
			})
			.then((res) => res.json())
			.then((data) => {
				return data || {};
			})
			.catch((reason) => {
				if (reason instanceof network.BadStatusError) {
					return reason.response;
				}

				throw reason;
			});
	};

export const experimentalTeamCalendarReminders: ExperimentalMutations['experimentalTeamCalendarReminders'] =
	(_, { subCalendarId, isReminder }, { network }) => {
		const formData = new URLSearchParams({
			subCalendarId,
			isReminder: String(isReminder),
		});

		return network
			.cfetch(
				`/wiki/rest/calendar-services/1.0/calendar/preferences/subcalendars/setreminder.json`,
				{
					method: 'PUT',
					headers: {
						Accept: MediaType.JSON,
						'X-Requested-With': 'XMLHttpRequest',
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					},
					body: formData.toString(),
				},
			)
			.then((res) => res.json());
	};

export const experimentalTeamCalendarPreferences: ExperimentalMutations['experimentalTeamCalendarPreferences'] =
	(_, { subCalendarId, calendarContext, viewingSpaceKey }, { network }) => {
		const formData = new URLSearchParams({
			subCalendarId,
			calendarContext,
		});
		if (viewingSpaceKey) {
			formData.append('viewingSpaceKey', viewingSpaceKey);
		}

		return network
			.cfetch(`/wiki/rest/calendar-services/1.0/calendar/subcalendars/preferences.json`, {
				method: 'DELETE',
				headers: {
					Accept: MediaType.JSON,
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				},
				body: formData.toString(),
			})
			.then((res) => res.json());
	};
